import { jsx as _jsx } from "react/jsx-runtime";
import { FTLDateUtils } from "ftl-core";
const FTLCredentialListCreatedAtCell = (data) => {
    const date = new Date(Number.parseFloat(data.createdAt) * 1000);
    return (_jsx("div", { children: FTLDateUtils.format(date) }, void 0));
};
export default FTLCredentialListCreatedAtCell;
//# sourceMappingURL=FTLCredentialListCreatedAtCell.js.map